export enum AssessmentStatus {
    PASSED = "Passed",
    FAILED = "Failed",
    MISSING = "Missing",
    NOT_APPLICABLE = "Not Applicable",
}